const messages = {
  pt: {
    translations: {
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Entrar",
          register: "Não tem um conta? Cadastre-se!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets hoje: ",
          },
        },
        messages: {
          inAttendance: {
            title: "Em Atendimento",
          },
          waiting: {
            title: "Aguardando",
          },
          closed: {
            title: "Finalizado",
          },
        },
      },
      connections: {
        title: "Conexões",
        toasts: {
          deleted: "Conexão com o WhatsApp excluída com sucesso!",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar WhatsApp",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: "Nome",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar WhatsApp",
          edit: "Editar WhatsApp",
        },
        form: {
          name: "Nome",
          default: "Padrão",
          farewellMessage: "Mensagem de despedida",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "WhatsApp salvo com sucesso.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os tickets relacionados serão perdidos.",
          importMessage: "Deseja importas todos os contatos do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
        },
        table: {
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Ações",
        },
      },
      crmKanban: {
        title: "CRM Kanban",
        newLead: "Novo Lead",
        manageStages: "Gerenciar Estágios",
        search: "Pesquisar...",
        filters: {
          connection: "Conexão",
          attendant: "Atendente",
          all: "Todos",
        },
        leadModal: {
          title: {
            add: "Adicionar Lead",
            edit: "Editar Lead",
          },
          form: {
            name: "Nome",
            number: "Número do WhatsApp",
            email: "Email",
            value: "Valor",
            stage: "Estágio",
            connection: "Conexão",
            attendant: "Atendente",
            notes: "Anotações",
            tag: "Tag",
            channel: "Canal",
            priority: "Prioridade",
          },
          buttons: {
            okAdd: "Adicionar",
            okEdit: "Salvar",
            cancel: "Cancelar",
            delete: "Excluir",
          },
          success: "Lead salvo com sucesso.",
          deleted: "Lead excluído com sucesso.",
          confirmDeleteTitle: "Excluir Lead",
          confirmDeleteMessage:
            "Tem certeza que deseja excluir este lead? Esta ação não pode ser revertida.",
        },
        stagesModal: {
          title: "Gerenciar Estágios",
          newStagePlaceholder: "Nome do novo estágio",
          saved: "Estágio salvo com sucesso.",
          deleted: "Estágio excluído com sucesso.",
          confirmDeleteTitle: "Excluir Estágio",
          confirmDeleteMessage:
            "Tem certeza? Os leads deste estágio serão realocados para o primeiro estágio.",
          buttons: {
            add: "Adicionar",
            save: "Salvar",
            delete: "Excluir",
            close: "Fechar",
          },
        },
      },
      crmPermissions: {
        title: "Permissões CRM",
        columns: {
          name: "Nome",
          email: "Email",
          profile: "Perfil",
        },
        toggles: {
          kanbanAccess: "Acesso ao Kanban",
          manageStages: "Gerenciar etapas",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
      },
      quickAnswersModal: {
        title: {
          add: "Adicionar Resposta Rápida",
          edit: "Editar Resposta Rápida",
        },
        form: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Resposta Rápida salva com sucesso.",
      },
      queueModal: {
        title: {
          add: "Adicionar fila",
          edit: "Editar fila",
        },
        form: {
          name: "Nome",
          color: "Cor",
          greetingMessage: "Mensagem de saudação",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      distributionRuleModal: {
        title: {
          add: "Nova regra de distribuição",
          edit: "Editar regra de distribuição",
        },
        form: {
          whatsapp: "Conexão",
          allConnections: "Todas",
          queue: "Fila",
          allQueues: "Todas",
          strategy: "Estratégia",
          members: "Atendentes",
          membersHelper:
            "Sem atendentes selecionados, a regra usa os atendentes da fila (ou todos os usuários comuns, quando a regra é geral).",
          noUsers: "Nenhum atendente encontrado",
          keepOwnerOnReopen: "Manter dono na reabertura",
          enabled: "Regra habilitada",
        },
        strategies: {
          round_robin: "Round robin",
          least_open: "Menor carga",
          random: "Aleatório",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Regra de distribuição salva com sucesso.",
      },
      userModal: {
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          profile: "Perfil",
          whatsapp: "Conexão Padrão",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Usuário salvo com sucesso.",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        toasts: {
          deleted: "O ticket que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar tickets e mensagens",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para fila",
        fieldConnectionLabel: "Transferir para conexão",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldConnectionPlaceholder: "Selecione uma conexão",
        noOptions: "Nenhum usuário encontrado com esse nome",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum ticket encontrado com esse status ou termo pesquisado",
        connectionTitle: "Conexão que está sendo utilizada atualmente.",
        buttons: {
          accept: "Aceitar",
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexões",
          tickets: "Tickets",
          contacts: "Contatos",
          crmKanban: "CRM Kanban",
          quickAnswers: "Respostas Rápidas",
          queues: "Filas",
          administration: "Administração",
          users: "Usuários",
          crmPermissions: "Permissões CRM",
          settings: "Configurações",
          saleAuditDashboard: "Auditoria IA",
          saleAudits: "Auditorias",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
          },
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
      },
      queues: {
        title: "Filas",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar fila",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os tickets dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queueSelect: {
        inputLabel: "Filas",
      },
      quickAnswers: {
        title: "Respostas Rápidas",
        table: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Resposta Rápida",
        },
        toasts: {
          deleted: "Resposta Rápida excluída com sucesso.",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle:
            "Você tem certeza que quer excluir esta Resposta Rápida: ",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
      },
      users: {
        title: "Usuários",
        table: {
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          whatsapp: "Conexão Padrão",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          saleAuditOnClose: {
            name: "Auditoria automática ao fechar atendimento",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
        },
        distributionRules: {
          title: "Distribuição de leads",
          description:
            "Atribui automaticamente novos tickets a um atendente, por conexão e/ou fila.",
          scope: {
            all: "Global",
          },
          membersCount: "{{count}} atendente(s)",
          empty: "Nenhuma regra de distribuição cadastrada.",
          deleteSuccess: "Regra de distribuição excluída com sucesso.",
          buttons: {
            add: "Nova regra",
          },
          confirmationModal: {
            title: "Excluir regra de distribuição",
            message:
              "Os tickets já atribuídos não são afetados. Novos tickets no escopo desta regra deixam de ser distribuídos automaticamente. Deseja continuar?",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Atribuído à:",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
          },
        },
      },
      messagesInput: {
        placeholderOpen:
          "Digite uma mensagem ou tecle ''/'' para utilizar as respostas rápidas cadastrada",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
      },
      saleAudit: {
        stages: {
          abordagem: "Abordagem",
          descoberta: "Descoberta",
          oferta: "Oferta",
          objecao: "Objeção",
          fechamento: "Fechamento",
          pos_venda: "Pós-venda",
        },
        temperatures: {
          quente: "Quente",
          morno: "Morno",
          frio: "Frio",
        },
        outcomes: {
          ganhou: "Ganhou",
          negociando: "Negociando",
          perdeu: "Perdeu",
          sem_venda: "Sem venda",
        },
        badges: {
          excelente: "Excelente",
          bom: "Bom",
          ruim: "Ruim",
        },
        verdicts: {
          good: "Bom",
          warn: "Atenção",
          bad: "Ruim",
        },
        kinds: {
          good: "Positivo",
          warn: "Atenção",
          bad: "Negativo",
          neutral: "Neutro",
        },
        emotions: {
          irritado: "Irritado",
          confuso: "Confuso",
          neutro: "Neutro",
          tranquilo: "Tranquilo",
          satisfeito: "Satisfeito",
        },
        impacts: {
          alto: "Alto",
          medio: "Médio",
          baixo: "Baixo",
        },
        levels: {
          junior: "Júnior",
          pleno: "Pleno",
          senior: "Sênior",
        },
        vsTeam: {
          acima: "Acima da equipe",
          na_media: "Na média da equipe",
          abaixo: "Abaixo da equipe",
        },
      },
      saleAuditDashboard: {
        title: "Auditoria de Atendimento (IA)",
        loading: "Carregando…",
        tabs: {
          quality: "Qualidade",
          conversations: "Atendimentos",
          sales: "Vendas",
        },
        filters: {
          dateFrom: "De",
          dateTo: "Até",
          connection: "Conexão",
          allConnections: "Todas",
          user: "Atendente",
          allUsers: "Todos",
        },
        kpis: {
          audited: "Auditadas",
          conversion: "Conversão",
          wonValue: "R$ ganho",
          lostValue: "R$ perdido",
          avgScore: "Nota média",
          badConversations: "Conversas ruins",
          agents: "Atendentes avaliados",
        },
        quality: {
          bands: {
            excelente: "Excelente",
            bom: "Bom",
            regular: "Regular",
            ruim: "Ruim",
          },
          distribution: {
            title: "Distribuição por faixa",
            empty: "Nenhuma conversa auditada no período.",
          },
          trend: {
            title: "Evolução da nota média",
            avgScore: "Nota média",
            empty: "Sem histórico de notas no período.",
          },
          ranking: {
            title: "Ranking de atendentes",
            user: "Atendente",
            audited: "Auditadas",
            avgScore: "Nota média",
            worstCategory: "Pior categoria",
            empty: "Nenhum atendente auditado no período.",
          },
          needsAttention: {
            title: "Precisa de atenção",
            description: "As 10 conversas com as piores notas do período.",
            score: "Nota",
            contact: "Cliente",
            user: "Atendente",
            topIssue: "Principal problema",
            empty: "Nenhuma conversa crítica no período.",
          },
        },
        funnel: {
          title: "Funil de vendas",
        },
        ranking: {
          title: "Ranking comercial",
          user: "Vendedor",
          audited: "Auditadas",
          conversion: "Conversão",
          avgScore: "Nota média",
          empty: "Nenhum vendedor auditado no período.",
        },
        lostReasons: {
          title: "Motivos de perda",
          empty: "Nenhum motivo de perda registrado.",
        },
        hotPending: {
          title: "Leads quentes parados",
          description:
            "Negociações quentes sem análise nova nas últimas 24 horas.",
          inNegotiation: "em negociação",
          cta: "Ver auditorias",
        },
        training: {
          title: "Onde treinar o time",
          worst: "Piores categorias",
          rest: "Demais categorias",
          empty: "Sem médias por categoria no período.",
        },
      },
      saleAudits: {
        title: "Auditorias de Atendimento",
        tabs: {
          all: "Todas",
        },
        filters: {
          outcome: "Resultado",
          all: "Todos",
        },
        table: {
          contact: "Cliente",
          user: "Atendente",
          score: "Nota",
          stage: "Etapa",
          temperature: "Temperatura",
          potentialValue: "Valor potencial",
          outcome: "Resultado",
          suggestedAction: "Próxima ação",
          firstContact: "Primeiro contato",
          lastContact: "Último contato",
          sortAscending: "Ordenado de forma crescente",
          sortDescending: "Ordenado de forma decrescente",
        },
        groups: {
          label: "Agrupar por",
          none: "Nenhum",
          user: "Atendente",
          connection: "Conexão",
          day: "Dia",
          noUser: "Sem atendente",
          summary: "{{count}} conversa(s) · nota média {{avgScore}}",
          summaryNoScore: "{{count}} conversa(s)",
        },
        buttons: {
          loadMore: "Carregar mais",
        },
        empty: "Nenhuma auditoria encontrada.",
      },
      saleAuditDrawer: {
        header: "Auditoria IA",
        empty: {
          title: "Este atendimento ainda não foi analisado.",
          description:
            "Rode a análise para receber score, sinais e a próxima jogada.",
        },
        score: "Score do atendimento",
        probability: "Probabilidade",
        potentialValue: "Valor potencial",
        confidence: "Confiança",
        model: "Modelo",
        analysisTime: "Análise",
        analyzedAt: "Analisado em",
        summary: "Resumo executivo",
        suggestedAction: "Próxima ação",
        suggestedMessage: "Jogada sugerida",
        sections: {
          play: "Jogada sugerida",
          categories: "Notas por categoria",
          benchmark: "Comparação com o time",
          timeline: "Timeline comentada",
          events: "Eventos importantes",
          emotions: "Evolução emocional",
          positives: "Destaques positivos",
          issues: "Problemas",
          missed: "Oportunidades perdidas",
          coaching: "Coaching",
        },
        evidence: {
          show: "Ver evidências",
          hide: "Ocultar evidências",
          msgRef: "msg #",
          empty: "Sem evidências.",
        },
        benchmark: {
          betterThan: "Melhor que {{pct}}% das conversas",
          sampleSize: "Amostra: {{count}} conversas auditadas",
          vsTeamAvg: "{{score}} · média do time {{teamAvg}}",
        },
        timeline: {
          client: "Cliente",
          seller: "Vendedor",
        },
        coaching: {
          train: "Treinar",
          level: "Nível",
          vsTeam: "Vs equipe",
          improveProb: "Prob. de melhoria",
        },
        toasts: {
          copied: "Mensagem copiada.",
          copyError: "Não foi possível copiar a mensagem.",
        },
        buttons: {
          analyze: "Analisar com IA",
          reanalyze: "Reanalisar",
          copy: "Copiar",
        },
      },
      audioTranscription: {
        label: "transcrição automática",
        seeFull: "Ver transcrição completa",
      },
      saleAuditDetail: {
        finalScore: "Nota final",
        seller: "Atendente",
        connection: "Conexão",
        weight: "peso",
        opinion: "Parecer da IA",
        conversation: {
          title: "Conversa auditada",
          empty: "Este atendimento não tem mensagens.",
          unmatched: "Comentários da IA sem mensagem correspondente",
          media: "[mídia]",
          mediaAudio: "🎵 áudio",
          mediaImage: "🖼️ imagem",
          mediaVideo: "🎬 vídeo",
          mediaFile: "📎 arquivo",
          mediaLocation: "📍 localização",
          mediaContact: "👤 contato",
          transcriptionLabel: "transcrição automática",
        },
        buttons: {
          print: "Imprimir / PDF",
          openFull: "Abrir auditoria completa",
        },
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
        },
        extraInfo: "Outras informações",
      },
      ticketOptionsMenu: {
        delete: "Deletar",
        transfer: "Transferir",
        confirmationModal: {
          title: "Deletar o ticket do contato",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_DISTRIBUTION_RULE_SCOPE_ALREADY_EXISTS:
          "Já existe uma regra de distribuição para esta conexão/fila.",
        ERR_DISTRIBUTION_RULE_INVALID_STRATEGY:
          "Estratégia de distribuição inválida.",
        ERR_NO_SALE_AUDIT_FOUND: "Este atendimento ainda não foi auditado.",
        ERR_CRM_FUNNEL_NOT_FOUND: "Funil não encontrado.",
        ERR_CRM_FUNNEL_INVALID_NAME: "Informe um nome válido para o funil.",
        ERR_CRM_FUNNEL_INVALID_COLOR: "Cor de funil inválida.",
        ERR_CRM_FUNNEL_NAME_ALREADY_EXISTS: "Já existe um funil com este nome.",
        ERR_CRM_FUNNEL_INVALID_ORDER: "Ordem de funis inválida.",
        ERR_FUNNEL_DEFAULT_UNDELETABLE: "O funil padrão não pode ser excluído.",
        ERR_FUNNEL_HAS_LEADS:
          "Este funil ainda tem leads. Mova ou exclua os leads antes de excluir o funil.",
        ERR_CRM_NO_FUNNEL: "Nenhum funil cadastrado.",
        ERR_CRM_STAGE_INVALID_NAME:
          "Informe um nome válido para a etapa (mínimo 2 caracteres).",
        ERR_CRM_STAGE_INVALID_COLOR: "Cor de etapa inválida.",
        ERR_CRM_STAGE_NAME_ALREADY_EXISTS:
          "Já existe uma etapa com este nome neste funil.",
        ERR_CRM_STAGE_INVALID_KIND: "Tipo de etapa inválido.",
        ERR_CRM_STAGE_INVALID_ORDER: "Ordem de etapas inválida.",
        ERR_CRM_STAGE_NOT_IN_FUNNEL:
          "Há etapas que não pertencem a este funil.",
        ERR_CRM_STAGE_NO_FALLBACK:
          "Não é possível excluir a última etapa do funil.",
        ERR_CRM_AUTOMATION_INVALID_TRIGGER:
          "Gatilho de automação inválido.",
      },
    },
  },
};

export { messages };
